import axios from "axios";
import config from "../../config/constants";
import { toastr } from 'react-redux-toastr';
import store from '../../containers/App/store';
import info from "../../config/messages";
import {loadProcessToken } from "../actions/index";

export const LOAD_COLLECTIONS = "LOAD_COLLECTIONS";
export const CREATE_COLLECTION = "CREATE_COLLECTION";
export const UPDATE_COLLECTION = "UPDATE_COLLECTION";
export const DELETE_COLLECTION = "DELETE_COLLECTION";
export const OPEN_COLLECTION = "OPEN_COLLECTION";


export const loadCollections = (props = {}, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        const { collection_name } = props;
        let url = config.API_URL + 'ai4ai/entities/collection';
        url = collection_name && collection_name.length > 0
          ? url + '?collection_name=' + collection_name : url;

        axios.get(url)
          .then(({ data }) => {
            console.log("received response");
            console.log(data);
            if (data){
                dispatch({
                    type: LOAD_COLLECTIONS,
                    payload: data.data
                });
            }
        }).catch(function (error) {
            console.log(error);
            if (error.response) {
                    if(error.response.data){
                       if(error.response.data.error){
                            toastr.error("Error", error.response.data.error);
                       } else{
                            toastr.error("Error", error.response.data);
                       }
                    } else{
                      toastr.error("Error", error.response);
                    }
            } else{
                    toastr.error("Unknown Error in retrieving collections", "Please refer the console logs for more details on the error.");
            }
        });
    }
}


export const createOrUpdateCollection= (props, scope) => {
    let token = loadProcessToken();
    if (props._id) {
        return (dispatch, getState) => {
            axios.put(config.API_URL + 'ai4ai/entities/collection', props).then(({ data }) => {
                dispatch({
                    type: UPDATE_COLLECTION,
                    payload: data.data
                });

                toastr.success('Successfully update the collection');
            }).catch(function (error) {
                console.log(error);
                if (error.response) {
                    if(error.response.data){
                       if(error.response.data.error){
                            toastr.error("Error", error.response.data.error);
                       } else{
                            toastr.error("Error", error.response.data);
                       }
                    } else{
                      toastr.error("Error", error.response);
                    }
                } else{
                    toastr.error("Unknown Error in updating collection", "Please refer the console logs for more details on the error.");
                }
            });
        }
    } else {
        return (dispatch, getState) => {
            axios.post(config.API_URL + 'ai4ai/entities/collection', props).then(({ data }) => {
                dispatch({
                    type: CREATE_COLLECTION,
                    payload: data.data
                });
                toastr.success('Successfully created the collection');
            }).catch(function (error) {
                console.log(error);
                if (error.response) {
                        if(error.response.data){
                           if(error.response.data.error){
                                toastr.error("Error", error.response.data.error);
                           } else{
                                toastr.error("Error", error.response.data);
                           }
                        } else{
                          toastr.error("Error", error.response);
                        }
                } else{
                        toastr.error("Unknown Error in creating collection", "Please refer the console logs for more details on the error.");
                }
            });
        }
    }
}

export const deleteCollection = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        axios.delete(config.API_URL + 'ai4ai/entities/collection/' + props._id).then(({ data }) => {
            dispatch({
                type: DELETE_COLLECTION,
                payload: props._id
            });
            toastr.success('Successfully deleted the collection');
        }).catch(function (error) {
                console.log(error);
                if (error.response) {
                        if(error.response.data){
                           if(error.response.data.error){
                                toastr.error("Error", error.response.data.error);
                           } else{
                                toastr.error("Error", error.response.data);
                           }
                        } else{
                          toastr.error("Error", error.response);
                        }
                } else{
                        toastr.error("Unknown Error in deleting collection", "Please refer the console logs for more details on the error.");
                }
        });
    }
}

export const openCollection = (props, scope) => {
     console.log("Received openCollection dispatch");
     return (dispatch, getState) => {
        dispatch({
            type: OPEN_COLLECTION,
            payload: props
        });
        console.log(" openCollection dispatched");
    };
}
